<div id="webshop" class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [ngClass]="paymentNavigations.length > 1 ? '' : 'center-tab'"
    [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <nav mat-tab-nav-bar class="ya-tab-nav-bar">
      <a mat-tab-link *ngFor="let pymentStep of paymentNavigations" [active]="activeLink == pymentStep" disabled
        [@shake]="states['state'+ pymentStep]" (click)="(activeLink!=pymentStep) && ShakeLabel('state'+ activeLink)">
        <span [langkey]="pymentStep"></span>
      </a>
    </nav>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <mat-tab-group [(selectedIndex)]="matGroupSelectedIndex" animationDuration="20ms">
      <mat-tab label="First">
        <ng-container *ngIf="locationImpressumData">
          <div class="basketLocation-detail-impressum">
            <div class="basketLocation-detail-content-wrapper">
              <div class="list-header_icon">
                <div class="icon-container">
                  <div class="inline-icon" inlineSVG="hypersoft-standort.svg"></div>
                </div>
              </div>
              <ul>
                <h2 *ngIf="hasContent(locationImpressumData.label)">{{locationImpressumData.label}}</h2>
                <li *ngIf="hasContent(locationImpressumData.address)">
                  <span>{{locationImpressumData.address}}</span>
                </li>
                <li *ngIf="hasContent(locationImpressumData.stnr)">
                  <span langkey="phInHouseLocalBasket_ImpressumDialog_stnr"></span>
                  <span class="basketLocation-detail-text">{{locationImpressumData.stnr}}</span>
                </li>
                <li *ngIf="hasContent(locationImpressumData.ustid)">
                  <span langkey="phInHouseLocalBasket_ImpressumDialog_ustid"></span>
                  <span class="basketLocation-detail-text">{{locationImpressumData.ustid}}</span>
                </li>
                <li *ngIf="hasContent(locationImpressumData.impressumHtml)">
                  <div (click)="openLocationImpressumDialog()" class="privacyLink">
                    <span langkey="phInHouseLocalBasket_ImpressumDialog"></span>
                  </div>
                </li>
              </ul>
              <ul>
                <li *ngIf="hasContent(locationImpressumData.commercial_register)">
                  <span langkey="phInHouseLocalBasket_ImpressumDialog_commercial_register"></span>
                  <span class="basketLocation-detail-text">{{locationImpressumData.commercial_register}}</span>
                </li>
                <li *ngIf="hasContent(locationImpressumData.representative)">
                  <span langkey="phInHouseLocalBasket_ImpressumDialog_representative"></span>
                  <span class="basketLocation-detail-text">{{locationImpressumData.representative}}</span>
                </li>
                <li *ngIf="hasContent(locationImpressumData.local_court)">
                  <span langkey="phInHouseLocalBasket_ImpressumDialog_local_court"></span>
                  <span class="basketLocation-detail-text">{{locationImpressumData.local_court}}</span>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="groupManageData">
          <div class="info-container">
            <h2>
              <span langkey="phRemoteOrder_Payment_Group"></span>
              <span class="groupName">{{groupManageData.groupName}}</span>
            </h2>
            <ng-container *ngIf="isGroupDelivery then DeliveryTemplate else PickUpTemplate"></ng-container>
            <ng-template #DeliveryTemplate>
              <div class="info-content__time">
                <span class="info-label" [innerHTML]="setGroupOrderEndTime(groupManageData.selectedOrderTime)"></span>
                <span class="info-label" [innerHTML]="setDeliveryEndTime(groupManageData.selectedServiceTime)"></span>
              </div>
              <div class="info-content__address">
                <span class="info-label info-right--space"
                  [innerHTML]="setDeliveryGroupAddress(groupManageData.groupDeliveryAddress)"></span>
                <ng-container *ngIf="locationData$|async; let location">
                  <span class="info-label" [innerHTML]="setDeliveryLocationName(location.name)"></span>
                </ng-container>
              </div>
            </ng-template>
            <ng-template #PickUpTemplate>
              <div class="info-content__time">
                <span class="info-label" [innerHTML]="setGroupOrderEndTime(groupManageData.selectedOrderTime)"></span>
                <span class="info-label" [innerHTML]="setPickupEndTime(groupManageData.selectedServiceTime)"></span>
              </div>
              <div class="info-content__address">
                <span class="info-label info-right--space" langkey="phRemoteOrder_Group_Pickup_Address"></span>
                <ng-container *ngIf="locationData$|async; let location">
                  <span class="info-label  emphasized ">{{location.street}}, {{location.zipCode + " "
                    +location.city}}</span>
                </ng-container>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <div class="group-basket">
          <div class="col">
            <!-- content user name sum total items list -->
            <ng-container *ngIf="orders$ | async; let orders">
              <div class="ya-item-list-contaner">
                <ng-container *ngFor="let order of orders; let i = index;">
                  <div class="order-list-content">
                    <div class="user-container">
                      <div class="user-content--top">
                        <div class="icon-container">
                          <div class="inline-icon" inlineSVG="hypersoft-user-list-single.svg">
                          </div>
                        </div>
                      </div>
                      <div class="user-info">
                        <div class="user_info_name">
                          <h3>{{order.userName}}</h3>
                        </div>
                        <div class="user_info_name">
                          <h3>{{formatCurrency(order.totalAmount)}}</h3>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngFor="let item of order.items; let i = index;">
                      <div class="item-wrapper">
                        <div class="info">
                          <div class="item">
                            <div class="orderItems-label-container">
                              <span class="item-label">{{item.count >1? item.count + "x " + item.label:
                                item.label}}</span>
                            </div>
                          </div>
                          <div class="item-price">
                            <span class="item-price_label">{{formatCurrency(item.price)}}</span>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
          <div class="col second">
            <div class="list-seperator"></div>
            <div class="group-order-sum">
              <span langkey="phGlobal_Sum"></span>
              <span>{{formatCurrency(sum$ | async)}}</span>
            </div>
            <ng-container *ngIf="serviceId === WebShopMode.DeliveryGroup">
              <ng-container *ngIf="deliveryFeeInfo$|async; let deliveryFeeInfo">
                <ng-container *ngIf="!deliveryFeeInfo.minimumPriceRequirementIsMet">
                  <div class="minimumDelivery-container">
                    <span langkey="phWebshop_ShippingCart_MinimumDelivery"></span>
                    <span class="bold">{{formatCurrency(deliveryFeeInfo.minimumDeliveryValue)}}</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="deliveryFeeInfo.showFreeShippingNotice">
                  <div class="minimumDelivery-container">
                    <span>{{getFreeShippingText(deliveryFeeInfo.remainingAmount)}}</span>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="canTip$|async">
              <div class="trinkgeld-container">
                <span langkey="phWebshop_Shippingcart_tip"></span>
                <div class="trinkgeld-slider-container">
                  <mat-slider #tipSlider min="0" max="50" step="1" (change)="onSliderValueChange()"
                    [(ngModel)]="tipSliderValue" thumbLabel [displayWith]="formatTipSliderLabel"></mat-slider>
                </div>
                <div class="trinkgeld-amount">
                  <div class="ya-input-container">
                    <input numericInput inputmode="decimal" class="ya-input-text" (blur)="setWebView()"
                      (change)="onInputTrinkgeldChange($event)" onfocus="this.select()" onpaste="return false;"
                      ondrop="return false" [(ngModel)]="tipInputValue">
                  </div>
                  <span>&nbsp;{{currencySymbol}}</span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="serviceId === WebShopMode.DeliveryGroup">
              <ng-container *ngIf="deliveryFeeInfo$|async; let deliveryFeeInfo">
                <ng-container *ngIf="deliveryFeeInfo.deliveryFee > 0">
                  <div class="price-container deliveryFee">
                    <span langkey="phWebshop_Shippingcart_DeliveryFee"></span>
                    <span>{{formatCurrency(deliveryFeeInfo.finalDeliveryFee)}}</span>
                  </div>
                </ng-container>
                <!-- Delivery total-->
                <div class="price-container total top-seperator">
                  <span langkey="phWebshop_ShippingCart_Total"></span>
                  <span>{{loadDeliveryTotal((total$ | async),deliveryFeeInfo.finalDeliveryFee)}}</span>
                </div>
              </ng-container>
            </ng-container>
            <!-- Pickup total-->
            <ng-container *ngIf="serviceId !== WebShopMode.DeliveryGroup">
              <div class="price-container total top-seperator">
                <span langkey="phWebshop_ShippingCart_Total"></span>
                <span>{{formatCurrency(total$ | async)}}</span>
              </div>
            </ng-container>
            <div class="payment-options-container__option term-container">
              <div class="input-checkbox-container">
                <mat-checkbox class="custom-ripple" [(ngModel)]="hasAcceptedAGB">
                </mat-checkbox>
              </div>
              <div #privacyContent (click)="onShowTermsClick($event)" class="payment-options-container__Text"
                [innerHtml]="AGB_innerhtml"></div>
            </div>
            <ng-container
              *ngIf="isShippingCartBtnActive()&&canContinue$ | async; let canContinue;then shippingCartActiveBtn else shippingCartDisableBtn">
            </ng-container>
            <ng-template #shippingCartActiveBtn>
              <div class="ya-webshop-button-container continue-button">
                <button mat-flat-button (click)="onContinue_basket()"><span
                    langkey="phInHouse_Continue_Btn"></span></button>
              </div>
            </ng-template>
            <ng-template #shippingCartDisableBtn>
              <div class="ya-webshop-button-container continue-button">
                <button mat-flat-button disabled><span langkey="phInHouse_Continue_Btn"></span></button>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Second">
        <ya-customerData #customerData class="ya-tab-content-wrapper second"
          (onContinue)="onContinue_customerData($event)"></ya-customerData>
      </mat-tab>
      <mat-tab label="Third">
        <div class="ya-tab-content-wrapper second">
          <ya-checkout #checkout></ya-checkout>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>